var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleRightFilledHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4ZM6.62435 3.22075C5.96952 2.69735 5 3.16358 5 4.00189V11.9953C5 12.8336 5.96952 13.2999 6.62435 12.7765L11.6247 8.77975C12.1256 8.37942 12.1256 7.6178 11.6247 7.21747L6.62435 3.22075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleRightFilledHovered);
export default __webpack_public_path__ + "static/media/triangle-right-filled-hovered.ac6728b18aae1bca6247d3aeb728c40d.svg";
export { ForwardRef as ReactComponent };